var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 300 300",
    width: 300,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff58d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -43.4L9.7 -13.4L41.3 -13.4L15.8 5.1L25.5 35.1L0 16.6L-25.5 35.1L-15.8 5.1L-41.3 -13.4L-9.7 -13.4Z",
    transform: "translate(198 157)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -19.8L4.4 -6.1L18.9 -6.1L7.2 2.3L11.7 16L0 7.6L-11.7 16L-7.2 2.3L-18.9 -6.1L-4.4 -6.1Z",
    transform: "translate(118 83)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.6a7833613bc64168471dfd80e88d20c9.svg";
export { ForwardRef as ReactComponent };